module.exports = __webpack_public_path__ + "img/2fae03c886e51ef54196aab.6ea8af79.svg";